import styled from "styled-components";

export const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  background: white;
  z-index: 999;
  padding: 10px 0;
  width: 100%;
  position: sticky;
  top: 52px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    gap: 10px;
    top: 48px;
  }
`;

export const TabSectionContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  position: relative;
  height: auto;
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: 0;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: visible;

  // 각 섹션에 상단 패딩 추가
  > div {
    scroll-margin-top: 120px; // Nav + TabContainer 높이 + 여유공간
    padding-top: 20px; // 컨텐츠 상단 여백
  }
`;

export const TabButton = styled.button<{ $isSelected: boolean }>`
  background: none;
  border: none;
  font-size: 18px;
  font-weight: 700;
  color: ${(props) => (props.$isSelected ? "#000000" : "#909090")};
  cursor: pointer;
  padding: 10px 20px;
  width: 180px;
  position: relative;
  transition: color 0.3s ease;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 100%;
    height: 2px;
    background-color: #000000;
    transform: scaleX(${(props) => (props.$isSelected ? 1 : 0)});
    transition: transform 0.3s ease;
  }

  &:hover::after {
    transform: scaleX(1);
  }

  @media (max-width: 1200px) {
    width: 160px;
    font-size: 17px;
  }

  @media (max-width: 992px) {
    width: 140px;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    width: 120px;
    font-size: 15px;
    padding: 8px 12px;
  }

  @media (max-width: 480px) {
    width: 100px;
    font-size: 14px;
    padding: 6px 8px;
  }
`;

export const StatContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const StatBox = styled.div`
  flex: 1;
  background: #ffffff;
  border-radius: 24px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 300px;

  @media (max-width: 768px) {
    padding: 24px;
    min-height: auto;
  }
`;

export const StatText = styled.div`
  color: #666666;
  font-family: Pretendard;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.6;
  white-space: pre-line;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const BoldText = styled.span`
  color: #000000;
  font-weight: 600;
`;

export const StatNumberContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-top: 24px;
`;

export const StatNumber = styled.div`
  color: #000000;
  font-family: Montserrat;
  font-size: 64px;
  font-weight: 700;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 48px;
  }
`;

export const StatPercent = styled.div`
  color: #666666;
  font-family: Pretendard;
  font-size: 32px;
  font-weight: 600;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const DeviceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;
  gap: 130px;

  @media (max-width: 1200px) {
    gap: 80px;
  }

  @media (max-width: 992px) {
    gap: 60px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
    padding: 20px;
    width: calc(100% - 40px);
    margin: 0 auto;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    width: 100%;
    margin: 0;
    box-sizing: border-box;
  }
`;

export const DeviceImage = styled.img`
  max-width: 100%;
  max-height: 680px;
  width: auto;
  height: auto;
  margin-left: auto;
  max-width: 65%;

  @media (max-width: 1200px) {
    max-width: 60%;
    max-height: 580px;
  }

  @media (max-width: 992px) {
    max-width: 55%;
    max-height: 480px;
  }

  @media (max-width: 768px) {
    width: 90%;
    max-width: 300px;
    height: auto;
    margin: 0 auto;
  }

  @media (max-width: 480px) {
    width: 100%;
    max-width: 100%;
    height: auto;
    margin-left: auto;
    margin-right: 0;
  }
`;

export const DeviceTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 680px;
  margin-left: 30px;
  text-align: left;
  width: 35%;

  @media (max-width: 1200px) {
    width: 40%;
  }

  @media (max-width: 992px) {
    width: 45%;
  }

  @media (max-width: 768px) {
    height: auto;
    padding: 0;
    margin-left: 0;
    width: 100%;
    text-align: center;

    h2 {
      font-size: 20px;
      line-height: 1.4;
      text-align: center;
      width: 100%;
      word-break: keep-all;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      line-height: 1.5;
      text-align: center;
      padding: 0;
      width: 100%;
      word-break: keep-all;
    }
  }

  @media (max-width: 480px) {
    width: 100%;
    height: auto;
    padding: 0;
    margin: 0;
    text-align: left;

    h2 {
      font-size: 20px;
      line-height: 1.4;
      text-align: left;
      width: 100%;
      margin-bottom: 10px;
      word-break: keep-all;
    }

    p {
      font-size: 14px;
      line-height: 1.5;
      text-align: left;
      width: 100%;
      word-break: keep-all;
    }
  }

  h2 {
    font-size: 40px;
    font-weight: 700;
    font-family: "Pretendard";
    line-height: 60px;
    margin-bottom: 2px;
    white-space: pre-line;

    @media (max-width: 768px) {
      font-size: 22px;
      line-height: 1.4;
      padding: 0 20px;
      word-break: keep-all;
    }

    @media (max-width: 480px) {
      font-size: 20px;
      line-height: 1.3;
      width: 100%;
      margin: 0;
      padding: 0;
      word-break: keep-all;
    }
  }

  p {
    font-size: 18px;
    font-weight: 600;
    color: #666;
    margin-bottom: 30px;
    white-space: pre-line;
    line-height: 28px;

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
      padding: 0 20px;
      word-break: keep-all;
    }

    @media (max-width: 480px) {
      font-size: 13px;
      width: 100%;
      margin: 10px 0 20px;
      padding: 0;
      word-break: keep-all;
    }
  }
`;
